import { translations } from '@tools/translations/translations';
import { isLength } from 'validator';
import Modal from '@components/Modal.vue';
import { createElementFromHtml } from '@tools/dom';
import { Logger } from '@tools/logger/logger';
import { URL_PRE_SET_LOGIN } from '@tools/routes/routes';
import { Attach } from '@tools/attach';
import { TwigFormValidator } from '@tools/twig-form/validator';
import { translationMixin } from '@tools/translation';
import { requestsMixin } from '@tools/requests-mixin';
import { eventBus } from '@tools/event-bus';

/**
 * Login Modal Component
 * This component use the modal component as a child.
 * It displays the login popin which displays the form.
 */
export const LoginPreSetModalComponent = {
  template: '#user-modal-component',
  components: {
    Modal,
  },
  mixins: [ translationMixin, requestsMixin ],
  delimiters: [ '${', '}' ],
  props: [ 'isOpened' ],
  data() {
    return {
      htmlBody: '',
      modalTitle: '',
    };
  },
  methods: {
    switchToLogin(args) {
      this.htmlBody = '';
      this.modalTitle = '';
      eventBus.dispatchEvent(new CustomEvent('switch-from-to-modal', {
        detail: {
          oldModalName: 'LoginPreSet',
          newModalName: 'Login',
          args,
        },
      }));
    },
    close() {
      this.htmlBody = '';
      this.modalTitle = '';
      this.$emit('close');
    },
    initFormValidation() {
      this.$nextTick(() => {
        const validator = new TwigFormValidator({
          formSelector: '#form-login-pre-set',
          rules: {
            'input[name=_password]': [ 'required', (value) => isLength(value, { min: 6 }) ],
          },
          messages: {
            'input[name=_password]': translations.messages['form.login.error.pwd_short'],
          },
          onSuccess: (event) => {
            Attach.asyncSubmit(event).then((result) => {
              const userModalDiv = document.getElementById('#login-pre-set-modal');
              const userName = userModalDiv.querySelector('#username').value;

              try {
                const jsonResponse = JSON.parse(result.data);

                // Success
                if (jsonResponse.reload) {
                  window.location.reload();
                  this.close();
                }
              } catch (exception) {
                const error = createElementFromHtml(result.data).querySelector('.error-message').innerText;
                this.switchToLogin([ userName, null, error ]);
              }
            })
              // init input placeholder animation after html added
              .then(this.$nextTick(() => {
                this.initFormValidation();
              }));
          },
        });
        validator.init();
      });
    },
    attachOnClickEventToOpenLoginModal() {
      Attach.onClickEvent('switch-login-button', () => {
        this.switchToLogin();
      });
    },
  },
  watch: {
    isOpened(newVal) {
      if (!newVal) {
        return;
      }

      this.modalTitle = this.trans('form.register.modal_title');

      this.get(URL_PRE_SET_LOGIN).then((responseLogin) => {
        this.htmlBody = responseLogin.data;
        this.attachOnClickEventToOpenLoginModal();
      }).catch((error) => {
        Logger.debug(error);
      });
    },
  },
};
